const e = [
  {
    color: "#D73027",
    value: "<-10K",
    ranges: [-1 / 0, -1e4],
    visible: !0
  },
  {
    color: "#F46D43",
    value: "-10K to -5K",
    ranges: [-1e4, -5e3],
    visible: !0
  },
  {
    color: "#FDAE61",
    value: "-5K to -500",
    ranges: [-5e3, -500],
    visible: !0
  },
  {
    color: "#FEE08B",
    value: "-500 to 0",
    ranges: [-500, 0],
    visible: !0
  },
  {
    color: "#D9EF8B",
    value: "0 to 500",
    ranges: [0, 500],
    visible: !0
  },
  {
    color: "#A6D96A",
    value: "500 to 5K",
    ranges: [500, 5e3],
    visible: !0
  },
  {
    color: "#66BD63",
    value: "5K to 10K",
    ranges: [5e3, 1e4],
    visible: !0
  },
  {
    color: "#1B6836",
    value: ">10K",
    ranges: [1e4, 1 / 0],
    visible: !0
  }
], r = [
  {
    color: "#D73027",
    value: "<-5K",
    ranges: [-1 / 0, -5e3],
    visible: !0
  },
  {
    color: "#F46D43",
    value: "-5K to -1K",
    ranges: [-5e3, -1e3],
    visible: !0
  },
  {
    color: "#FDAE61",
    value: "-1K to -200",
    ranges: [-1e3, -200],
    visible: !0
  },
  {
    color: "#FEE08B",
    value: "-200 to 0",
    ranges: [-200, 0],
    visible: !0
  },
  {
    color: "#D9EF8B",
    value: "0 to 200",
    ranges: [0, 200],
    visible: !0
  },
  {
    color: "#A6D96A",
    value: "200 to 1K",
    ranges: [200, 1e3],
    visible: !0
  },
  {
    color: "#66BD63",
    value: "1K to 5K",
    ranges: [1e3, 5e3],
    visible: !0
  },
  {
    color: "#1B6836",
    value: ">5K",
    ranges: [5e3, 1 / 0],
    visible: !0
  }
], l = [
  {
    color: "#D73027",
    value: "<-3K",
    ranges: [-1 / 0, -3e3],
    visible: !0
  },
  {
    color: "#F46D43",
    value: "-3K to -500",
    ranges: [-3e3, -500],
    visible: !0
  },
  {
    color: "#FDAE61",
    value: "-500 to -100",
    ranges: [-500, -100],
    visible: !0
  },
  {
    color: "#FEE08B",
    value: "-100 to 0",
    ranges: [-100, 0],
    visible: !0
  },
  {
    color: "#D9EF8B",
    value: "0 to 100",
    ranges: [0, 100],
    visible: !0
  },
  {
    color: "#A6D96A",
    value: "100 to 500",
    ranges: [100, 500],
    visible: !0
  },
  {
    color: "#66BD63",
    value: "500 to 3K",
    ranges: [500, 3e3],
    visible: !0
  },
  {
    color: "#1B6836",
    value: ">3K",
    ranges: [3e3, 1 / 0],
    visible: !0
  }
], o = [
  {
    color: "#D73027",
    value: "<-10K",
    ranges: [-1 / 0, -1e4],
    visible: !0
  },
  {
    color: "#F46D43",
    value: "-10K to -5K",
    ranges: [-1e4, -5e3],
    visible: !0
  },
  {
    color: "#FDAE61",
    value: "-5K to -500",
    ranges: [-5e3, -500],
    visible: !0
  },
  {
    color: "#FEE08B",
    value: "-500 to 0",
    ranges: [-500, 0],
    visible: !0
  },
  {
    color: "#D9EF8B",
    value: "0 to 500",
    ranges: [0, 500],
    visible: !0
  },
  {
    color: "#A6D96A",
    value: "500 to 5K",
    ranges: [500, 5e3],
    visible: !0
  },
  {
    color: "#66BD63",
    value: "5K to 10K",
    ranges: [5e3, 1e4],
    visible: !0
  },
  {
    color: "#1B6836",
    value: ">10K",
    ranges: [1e4, 1 / 0],
    visible: !0
  }
], i = [
  {
    color: "#D73027",
    value: "<-5K",
    ranges: [-1 / 0, -5e3],
    visible: !0
  },
  {
    color: "#F46D43",
    value: "-5K to -1K",
    ranges: [-5e3, -1e3],
    visible: !0
  },
  {
    color: "#FDAE61",
    value: "-1K to -200",
    ranges: [-1e3, -200],
    visible: !0
  },
  {
    color: "#FEE08B",
    value: "-200 to 0",
    ranges: [-200, 0],
    visible: !0
  },
  {
    color: "#D9EF8B",
    value: "0 to 200",
    ranges: [0, 200],
    visible: !0
  },
  {
    color: "#A6D96A",
    value: "200 to 1K",
    ranges: [200, 1e3],
    visible: !0
  },
  {
    color: "#66BD63",
    value: "1K to 5K",
    ranges: [1e3, 5e3],
    visible: !0
  },
  {
    color: "#1B6836",
    value: ">5K",
    ranges: [5e3, 1 / 0],
    visible: !0
  }
], s = [
  {
    color: "#D73027",
    value: "<-3K",
    ranges: [-1 / 0, -3e3],
    visible: !0
  },
  {
    color: "#F46D43",
    value: "-3K to -500",
    ranges: [-3e3, -500],
    visible: !0
  },
  {
    color: "#FDAE61",
    value: "-500 to -100",
    ranges: [-500, -100],
    visible: !0
  },
  {
    color: "#FEE08B",
    value: "-100 to 0",
    ranges: [-100, 0],
    visible: !0
  },
  {
    color: "#D9EF8B",
    value: "0 to 100",
    ranges: [0, 100],
    visible: !0
  },
  {
    color: "#A6D96A",
    value: "100 to 500",
    ranges: [100, 500],
    visible: !0
  },
  {
    color: "#66BD63",
    value: "500 to 3K",
    ranges: [500, 3e3],
    visible: !0
  },
  {
    color: "#1B6836",
    value: ">3K",
    ranges: [3e3, 1 / 0],
    visible: !0
  }
], t = [
  {
    color: "#D73027",
    value: "<-3.0%",
    ranges: [-1 / 0, -3],
    visible: !0
  },
  {
    color: "#F46D43",
    value: "-3.0% to -2.0%",
    ranges: [-3, -2],
    visible: !0
  },
  {
    color: "#FDAE61",
    value: "-2.0% to -1.0%",
    ranges: [-2, -1],
    visible: !0
  },
  {
    color: "#FEE08B",
    value: "-1.0% to 0",
    ranges: [-1, 0],
    visible: !0
  },
  {
    color: "#D9EF8B",
    value: "0 to 1.0%",
    ranges: [0, 1],
    visible: !0
  },
  {
    color: "#A6D96A",
    value: "1.0% to 2.0%",
    ranges: [1, 2],
    visible: !0
  },
  {
    color: "#66BD63",
    value: "2.0% to 3.0%",
    ranges: [2, 3],
    visible: !0
  },
  {
    color: "#1B6836",
    value: ">3.0%",
    ranges: [3, 1 / 0],
    visible: !0
  }
], a = [
  {
    color: "#D73027",
    value: "<-10.0%",
    ranges: [-1 / 0, -10],
    visible: !0
  },
  {
    color: "#F46D43",
    value: "-10.0% to -5.0%",
    ranges: [-10, -5],
    visible: !0
  },
  {
    color: "#FDAE61",
    value: "-5.0% to -3.0%",
    ranges: [-5, -3],
    visible: !0
  },
  {
    color: "#FEE08B",
    value: "-3.0% to 0",
    ranges: [-3, 0],
    visible: !0
  },
  {
    color: "#D9EF8B",
    value: "0 to 3.0%",
    ranges: [0, 3],
    visible: !0
  },
  {
    color: "#A6D96A",
    value: "3.0% to 5.0%",
    ranges: [3, 5],
    visible: !0
  },
  {
    color: "#66BD63",
    value: "5.0% to 10.0%",
    ranges: [5, 10],
    visible: !0
  },
  {
    color: "#1B6836",
    value: ">10.0%",
    ranges: [10, 1 / 0],
    visible: !0
  }
], u = {
  cbsa: {
    visible: !0,
    range: [3, 6]
  },
  county: {
    visible: !0,
    range: [6, 9]
  },
  zipcode: {
    visible: !0,
    range: [9, 12]
  },
  cbg: {
    visible: !1
  }
}, v = {
  cbsa: {
    visible: !0,
    range: [3, 6]
  },
  county: {
    visible: !0,
    range: [6, 7]
  },
  zipcode: {
    visible: !0,
    range: [7, 12]
  },
  cbg: {
    visible: !1
  }
};
export {
  o as MIGRATION_POPULATION_CHANGE_STATIC_CBSA_BINS,
  i as MIGRATION_POPULATION_CHANGE_STATIC_COUNTY_BINS,
  s as MIGRATION_POPULATION_CHANGE_STATIC_ZIPCODE_BINS,
  t as MIGRATION_POPULATION_PERCENT_CHANGE_STATIC_CBSA_COUNTY_BINS,
  a as MIGRATION_POPULATION_PERCENT_CHANGE_STATIC_ZIPCODE_BINS,
  u as MIGRATION_TREND_ZOOM_DETAILS,
  v as MIGRATION_TREND_ZOOM_DETAILS_0504,
  e as NET_MIGRATION_STATIC_CBSA_BINS,
  r as NET_MIGRATION_STATIC_COUNTY_BINS,
  l as NET_MIGRATION_STATIC_ZIPCODE_BINS
};
//# sourceMappingURL=index.es479.js.map
